import { isSmallProjectFee } from '~/core/helpers';
import { CommonProductModel } from '~/core/models';

const hiddenProductsFilters = [isSmallProjectFee];

export const filterOutHiddenProducts = <Product extends CommonProductModel>(
  products: Product[]
): Product[] => {
  const isHiddenProduct = (product: Product) =>
    hiddenProductsFilters.some((filter) => filter(product));

  return products.filter((product) => !isHiddenProduct(product));
};
